import { Formik } from 'formik'
import { ReactElement, useCallback } from 'react'
import { useSetRecoilState } from 'recoil'
import axios from 'axios'
import { getServerHost } from '../utils/get-server-host'

import { IAccessRole } from '../types/types'
import { getHeaders } from '../utils/get-headers'
import { accessRolesState } from '../states/access-roles-state'

interface FormErrors {
  name?: string
  codename?: string
}

const INITIAL_VALUES: IAccessRole = {
  id: 0,
  name: '',
  codename: '',
}

const AccessRoleForm = (): ReactElement => {
  const setAccessRoles = useSetRecoilState(accessRolesState)

  const onSubmit = useCallback(async (values, { setSubmitting }) => {
    const { name, codename } = values
    const { data } = await axios.post(
      getServerHost('access-role'),
      {
        name,
        codename,
      },
      { headers: getHeaders() },
    )

    if (data.accessRole) {
      // Log user
      setAccessRoles((prevState) => [...prevState, data.accessRole])
    }
  }, [])

  return (
    <Formik initialValues={INITIAL_VALUES} onSubmit={onSubmit}>
      {({ values, errors, touched, handleChange, handleBlur, handleSubmit, isSubmitting }) => (
        // @ts-ignore
        <form onSubmit={handleSubmit}>
          <input
            type="text"
            name="name"
            onChange={handleChange}
            onBlur={handleBlur}
            placeholder="name"
            value={values.name}
            className="input input-bordered w-full min-w-8 mb-4"
          />
          <input
            type="text"
            name="codename"
            onChange={handleChange}
            onBlur={handleBlur}
            placeholder="codename"
            value={values.codename}
            className="input input-bordered w-full min-w-8 mb-4"
          />
          <button type="submit" className="btn btn-outline" disabled={isSubmitting}>
            Submit
          </button>
        </form>
      )}
    </Formik>
  )
}

export default AccessRoleForm